import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import { tweenAzimuthalAngleTo } from "../../three/tween/tweenAzimuthalAngleTo"
import { tweenPolarAngleTo } from "../../three/tween/tweenPolarAngleTo"
import { EntityTypeId } from "../entity/EntityTypeId.enum"
import { PI } from "../util/math/Math"

export default function setDefaultMapControlArmyPainterAngle (
  controls: OrbitControls,
  etype_id: EntityTypeId | undefined
): void {
  tweenPolarAngleTo(controls, getEtmPolarAngle(etype_id), 1500)
  tweenAzimuthalAngleTo(controls, getEtmAzimuthalAngle(etype_id), 1500)
}
const polarAngles : Partial<Record<EntityTypeId, number>> = {
  [EntityTypeId.Infantry]: 0.339,
  [EntityTypeId.LightRecon]: 0.35,
  [EntityTypeId.LightTank]: 0.366,
  [EntityTypeId.MediumArtillary]: 0.388,
  [EntityTypeId.MediumCopter]: 0.35,
  [EntityTypeId.MediumMissileAntiAir]: 0.41,
  [EntityTypeId.MediumRockets]: 0.398,
  [EntityTypeId.MediumTank]: 0.36,
  [EntityTypeId.TransportCopter]: 0.35,
  [EntityTypeId.APC]: 0.355,
  [EntityTypeId.Building]: 0.377,
  [EntityTypeId.Factory]: 0.358,
  [EntityTypeId.HQ]: 0.366,
}
function getEtmPolarAngle(etype_id: EntityTypeId | undefined) {
  return PI * (polarAngles[etype_id as EntityTypeId] || 0.0856)
}
const azimuthalAngles : Partial<Record<EntityTypeId, number>> = {
  [EntityTypeId.Infantry]: 0.26,
  [EntityTypeId.LightRecon]: 0.26,
  [EntityTypeId.LightTank]: 0.18,
  [EntityTypeId.MediumArtillary]: 0.254,
  [EntityTypeId.MediumCopter]: 0.14,
  [EntityTypeId.MediumMissileAntiAir]: 0.1945,
  [EntityTypeId.MediumRockets]: 0.28,
  [EntityTypeId.MediumTank]: 0.156,
  [EntityTypeId.TransportCopter]: 0.23,
  [EntityTypeId.APC]: 0.1945,
  [EntityTypeId.Building]: 0.186,
  [EntityTypeId.Factory]: 0.184,
  [EntityTypeId.HQ]: -0.12655,
}
function getEtmAzimuthalAngle(etype_id: EntityTypeId | undefined) {
  return PI * (azimuthalAngles[etype_id as EntityTypeId] || 0.38)
}
